var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
/* eslint-disable react/no-multi-comp */
import React, { useCallback, useEffect, useRef, useState, } from "react";
import { map, path, equals, startsWith, none, pathOr } from "ramda";
import { Field, Form, Formik } from "formik";
import { Money } from "@upserve/financials";
import styled from "styled-components";
import cn from "classnames";
import { TrackJS } from "trackjs";
import { useFlags } from "launchdarkly-react-client-sdk";
import { getRecaptchaToken, loadGoogleRecaptcha, } from "helpers/google_recaptcha";
import Validators from "helpers/validation/validators";
import VALIDATION_MESSAGES from "helpers/validation/messages";
import Loader from "components/loader";
import GratuityComponent from "components/gratuity_component";
import { StyledWrapper } from "components/mobile_pay/views/page";
import MobileCreditCardSubmissionFrame from "components/mobile_pay/mobile_credit_card_submission_frame";
import Overlay from "components/overlay";
import { RequestStatus } from "types/requests";
var StyledPaymentHeading = styled.h1(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  margin: 0 0 30px;\n\n  color: #000;\n\n  font-size: 24px;\n  font-weight: bold;\n"], ["\n  margin: 0 0 30px;\n\n  color: #000;\n\n  font-size: 24px;\n  font-weight: bold;\n"])));
var StyledFormControl = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n\n  padding-bottom: 30px;\n\n  position: relative;\n\n  &.expiryMonth,\n  &.expiryYear,\n  &.cvv {\n    width: 30%;\n\n    @media (max-width: 307px) {\n      width: 47%;\n    }\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n\n  padding-bottom: 30px;\n\n  position: relative;\n\n  &.expiryMonth,\n  &.expiryYear,\n  &.cvv {\n    width: 30%;\n\n    @media (max-width: 307px) {\n      width: 47%;\n    }\n  }\n"])));
export var StyledLabel = styled.label(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  align-self: flex-start;\n  margin-bottom: 9px;\n  min-height: 18px;\n\n  color: #5a5a5a;\n\n  font-size: 16px;\n  font-weight: bold;\n"], ["\n  align-self: flex-start;\n  margin-bottom: 9px;\n  min-height: 18px;\n\n  color: #5a5a5a;\n\n  font-size: 16px;\n  font-weight: bold;\n"])));
var StyledInput = styled.input(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  padding: 15px;\n  @media (max-width: 375px) {\n    padding: 12px;\n  }\n  @media (max-width: 320px) {\n    padding: 10px;\n  }\n\n  font-size: 24px;\n  border: 1px solid #ededed;\n\n  &:focus {\n    border-color: #5a5a5a;\n  }\n\n  &.error {\n    border: 1px solid #e02948;\n  }\n"], ["\n  padding: 15px;\n  @media (max-width: 375px) {\n    padding: 12px;\n  }\n  @media (max-width: 320px) {\n    padding: 10px;\n  }\n\n  font-size: 24px;\n  border: 1px solid #ededed;\n\n  &:focus {\n    border-color: #5a5a5a;\n  }\n\n  &.error {\n    border: 1px solid #e02948;\n  }\n"])));
var StyledGroupedFields = styled.div(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  justify-content: space-between;\n\n  margin-bottom: 18px;\n"], ["\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n\n  justify-content: space-between;\n\n  margin-bottom: 18px;\n"])));
var StyledFormButton = styled.div(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  display: flex;\n  min-height: 4rem;\n\n  flex-direction: column;\n\n  button {\n    flex: 1;\n\n    font-size: 20px;\n    font-weight: bold;\n    background: #3e5b83;\n  }\n\n  button:disabled {\n    cursor: pointer;\n    background-color: #b5b5b5;\n  }\n"], ["\n  display: flex;\n  min-height: 4rem;\n\n  flex-direction: column;\n\n  button {\n    flex: 1;\n\n    font-size: 20px;\n    font-weight: bold;\n    background: #3e5b83;\n  }\n\n  button:disabled {\n    cursor: pointer;\n    background-color: #b5b5b5;\n  }\n"])));
var StyledErrorMessage = styled.div(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  color: #e02948;\n  position: absolute;\n  top: 92px;\n  left: 0;\n  text-align: left;\n\n  @media (max-width: 375px) {\n    top: 86px;\n  }\n"], ["\n  color: #e02948;\n  position: absolute;\n  top: 92px;\n  left: 0;\n  text-align: left;\n\n  @media (max-width: 375px) {\n    top: 86px;\n  }\n"])));
var StyledSubmissionErrorMessage = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  position: relative;\n  bottom: 10px;\n\n  align-self: flex-start;\n\n  font-size: 16px;\n  color: #e02948;\n"], ["\n  position: relative;\n  bottom: 10px;\n\n  align-self: flex-start;\n\n  font-size: 16px;\n  color: #e02948;\n"])));
var StyledProcessingLoader = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  height: 60%;\n  width: 60%;\n  padding-top: 100px;\n\n  font-size: 24px;\n\n  background-color: #ffffff;\n  border-radius: 5px;\n\n  text-align: center;\n"], ["\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  -webkit-transform: translate(-50%, -50%);\n  transform: translate(-50%, -50%);\n  height: 60%;\n  width: 60%;\n  padding-top: 100px;\n\n  font-size: 24px;\n\n  background-color: #ffffff;\n  border-radius: 5px;\n\n  text-align: center;\n"])));
export default function CreditCardForm(_a) {
    var merchantInfo = _a.merchantInfo, checkInfo = _a.checkInfo, processedPaymentInfoRequest = _a.processedPaymentInfoRequest, creditCardRequestStatus = _a.creditCardRequestStatus, submitCreditCardPayment = _a.submitCreditCardPayment, setCreditCardRequestStatus = _a.setCreditCardRequestStatus;
    var timeoutRef = useRef(null);
    var _b = useState(Money(0)), tip = _b[0], setTip = _b[1];
    var _c = useState(undefined), selectedTipOption = _c[0], setSelectedTipOption = _c[1];
    var _d = useState(true), isTipValid = _d[0], setIsTipValid = _d[1];
    var _e = useState({
        firstName: "",
        lastName: "",
        cardNumber: "",
        expiryMonth: "",
        expiryYear: "",
        cvv: "",
        email: "",
        phone: "",
    }), cardInfo = _e[0], setCardInfo = _e[1];
    var paymentError;
    if (equals(RequestStatus.FAILURE, creditCardRequestStatus)) {
        paymentError = (React.createElement(StyledSubmissionErrorMessage, { className: "error payment-error" }, pathOr("There was an error processing your request. Please check the form and try again.", ["reason"], processedPaymentInfoRequest)));
    }
    // form submission
    var ccSubmissionRef = useRef();
    var _f = useState(false), ccFrameActive = _f[0], setCcFrameActive = _f[1];
    var handlePaymentMethodToken = useCallback(function (event) {
        if (!equals("upserve-payments", event.data.source)) {
            return;
        }
        if (timeoutRef.current) {
            // clear timeout after card vaulting
            clearTimeout(timeoutRef.current);
        }
        if (event.data.paymentMethodToken) {
            var paymentMethodToken = event.data.paymentMethodToken;
            submitCreditCardPayment({
                checkInfo: checkInfo,
                total: checkInfo.balanceDue,
                balanceDue: Money(0),
                tip: tip,
                paymentMethodToken: paymentMethodToken,
                cardInfo: cardInfo,
            });
        }
        else {
            TrackJS.track("error vaulting credit card");
            setCreditCardRequestStatus(RequestStatus.FAILURE);
            setCcFrameActive(false);
        }
    }, [cardInfo]);
    useEffect(function () {
        var paymentHandler = function (event) {
            handlePaymentMethodToken(event);
        };
        window.addEventListener("message", paymentHandler);
        loadGoogleRecaptcha();
        return function () {
            window.removeEventListener("message", paymentHandler);
        };
    }, [handlePaymentMethodToken]);
    var flags = useFlags();
    var formSubmit = useCallback(function (values, _a) {
        var setSubmitting = _a.setSubmitting;
        setCreditCardRequestStatus(RequestStatus.REQUESTING);
        setCardInfo(__assign({}, values));
        setCcFrameActive(true);
        if (timeoutRef.current) {
            clearTimeout(timeoutRef.current);
        }
        var doSubmit = path(["current", "doSubmit"], ccSubmissionRef);
        if (typeof doSubmit === "function") {
            if (flags.oloCreditCardRecaptcha) {
                var onError = function () {
                    return setCreditCardRequestStatus(RequestStatus.FAILURE);
                };
                var onSuccess = doSubmit;
                getRecaptchaToken({ onError: onError, onSuccess: onSuccess });
            }
            else {
                doSubmit();
            }
            timeoutRef.current = setTimeout(function () {
                TrackJS.track("credit card vaulting timed out after 30s");
                setCreditCardRequestStatus(RequestStatus.FAILURE);
                setCcFrameActive(false);
            }, 30000);
        }
        else {
            TrackJS.track("credit card submission frame unavailable for submission");
        }
        setSubmitting(false);
    }, [ccSubmissionRef, creditCardRequestStatus, flags]);
    // form validation
    var ccFieldRef = useRef();
    function validateFirstName(name) {
        return !Validators.isNotEmpty(name) ? VALIDATION_MESSAGES.firstName : null;
    }
    function validateLastName(name) {
        return !Validators.isNotEmpty(name) ? VALIDATION_MESSAGES.lastName : null;
    }
    function validateCreditCard(cardNumber) {
        return !Validators.isValidCardNumber(cardNumber)
            ? VALIDATION_MESSAGES.cardNumber
            : null;
    }
    function validateExpiryMonth(month) {
        return !Validators.isValidMonth(month)
            ? VALIDATION_MESSAGES.expiryMonth
            : null;
    }
    function validateExpiryYear(year) {
        return !Validators.isValidExpirationYear(year)
            ? VALIDATION_MESSAGES.expiryYear
            : null;
    }
    function validateCvv(cvv) {
        var cardNumber = ccFieldRef.current ? ccFieldRef.current.value : null;
        var data = {
            cardNumber: cardNumber,
        };
        return !Validators.isValidCvv(cvv, data) ? VALIDATION_MESSAGES.cvv : null;
    }
    function validateEmail(email) {
        return !Validators.isValidEmail(email) ? VALIDATION_MESSAGES.email : null;
    }
    function validatePhone(phone) {
        return !equals("", phone) &&
            (!Validators.isValidPhoneNumber(phone) || !Validators.isNANP(phone))
            ? VALIDATION_MESSAGES.phone
            : null;
    }
    function getCardNumberLimit(values) {
        return startsWith("3", values.cardNumber) ? "15" : "16";
    }
    function onCardNumberChange(event, setFieldValue) {
        setFieldValue("cardNumber", event.target.value.replace(/[^0-9.]+/g, ""));
    }
    function onExpiryMonthBlur(event, setFieldValue, setFieldTouched) {
        var value = event.target.value;
        if (value > 0) {
            value = value.padStart(2, "0");
        }
        setFieldValue("expiryMonth", value);
        setFieldTouched("expiryMonth");
    }
    function onExpiryYearBlur(event, setFieldValue, setFieldTouched) {
        var value = event.target.value;
        if (value > 0 && value.length === 2) {
            value = value.padStart(4, "20");
        }
        setFieldValue("expiryYear", value);
        setFieldTouched("expiryYear");
    }
    // form inputs
    var inputs = [
        {
            name: "firstName",
            label: "First Name",
            autocomplete: "given-name",
            validate: validateFirstName,
            ref: null,
        },
        {
            name: "lastName",
            label: "Last Name",
            autocomplete: "family-name",
            validate: validateLastName,
            ref: null,
        },
        {
            name: "cardNumber",
            label: "Card Number",
            autocomplete: "cc-number",
            inputmode: "numeric",
            validate: validateCreditCard,
            ref: ccFieldRef,
            maxLength: getCardNumberLimit,
            onChange: onCardNumberChange,
        },
        {
            grouping: [
                {
                    name: "expiryMonth",
                    label: "Expiration",
                    autocomplete: "cc-exp-month",
                    inputmode: "numeric",
                    validate: validateExpiryMonth,
                    placeholder: "MM",
                    ref: null,
                    maxLength: "2",
                    onBlur: onExpiryMonthBlur,
                    ariaLabel: "expiration month",
                },
                {
                    name: "expiryYear",
                    label: " ",
                    autocomplete: "cc-exp-year",
                    inputmode: "numeric",
                    validate: validateExpiryYear,
                    placeholder: "YYYY",
                    ref: null,
                    maxLength: "4",
                    onBlur: onExpiryYearBlur,
                    ariaLabel: "expiration year",
                },
                {
                    name: "cvv",
                    label: "CVV",
                    autocomplete: "cc-csc",
                    inputmode: "numeric",
                    validate: validateCvv,
                    ref: null,
                },
            ],
        },
        {
            name: "gratuity-placeholder",
        },
        {
            name: "email",
            label: "Email for Receipt",
            autocomplete: "email",
            inputmode: "email",
            validate: validateEmail,
            ref: null,
        },
        {
            name: "phone",
            label: "Phone Number (Optional)",
            autocomplete: "tel",
            inputmode: "tel",
            validate: validatePhone,
            ref: null,
        },
    ];
    var submitDisabled = function (isValid, dirty) {
        var isFormInvalid = !isValid ||
            (equals(RequestStatus.NOT_STARTED, creditCardRequestStatus) && !dirty);
        return isFormInvalid || !isTipValid;
    };
    var tipSettings = {
        customTipsEnabled: merchantInfo.customTipsEnabled,
        showSuggestedTips: merchantInfo.showSuggestedTips,
        suggestedTipDefault: merchantInfo.suggestedTipDefault,
        suggestedTipPercentHigh: merchantInfo.suggestedTipPercentHigh,
        suggestedTipPercentLow: merchantInfo.suggestedTipPercentLow,
        suggestedTipPercentMiddle: merchantInfo.suggestedTipPercentMiddle,
    };
    return (React.createElement(React.Fragment, null,
        equals(RequestStatus.REQUESTING, creditCardRequestStatus) && (React.createElement(Overlay, null,
            React.createElement(StyledProcessingLoader, null,
                React.createElement(Loader, null, "We're processing your card...")))),
        ccFrameActive && (React.createElement(MobileCreditCardSubmissionFrame, { key: "ccSubmission", ref: ccSubmissionRef, card: cardInfo, merchantKey: merchantInfo.ugMerchantKey, hasRecaptchaInput: flags.oloCreditCardRecaptcha })),
        React.createElement(Formik, { initialValues: {
                firstName: cardInfo.firstName,
                lastName: cardInfo.lastName,
                cardNumber: cardInfo.cardNumber,
                expiryMonth: cardInfo.expiryMonth,
                expiryYear: cardInfo.expiryYear,
                cvv: cardInfo.cvv,
                email: cardInfo.email,
                phone: cardInfo.phone,
            }, onSubmit: formSubmit, validateOnBlur: false }, function (_a) {
            var errors = _a.errors, touched = _a.touched, isValid = _a.isValid, dirty = _a.dirty, values = _a.values, setFieldValue = _a.setFieldValue, handleChange = _a.handleChange, handleBlur = _a.handleBlur, setFieldTouched = _a.setFieldTouched;
            return (React.createElement(Form, { translate: "yes" },
                React.createElement(StyledWrapper, null,
                    React.createElement(StyledPaymentHeading, null, "Pay with Credit Card"),
                    map(function (inputDefinition) {
                        if (inputDefinition.name === "gratuity-placeholder") {
                            return (React.createElement(GratuityComponent, { key: "gratuity component", tipSettings: tipSettings, preTaxTotal: checkInfo.balanceDue, setTip: setTip, setIsTipValid: setIsTipValid, setSelectedTipOption: setSelectedTipOption, selectedTipOption: selectedTipOption, variant: "mobile-pay" }));
                        }
                        function makeControl(input) {
                            var inputRequired = !equals(input.name, "phone");
                            return (React.createElement(StyledFormControl, { className: input.name, key: input.name },
                                none(equals(input.name), [
                                    "expiryMonth",
                                    "expiryYear",
                                ]) ? (React.createElement(StyledLabel, { htmlFor: input.name }, input.label)) : (React.createElement(StyledLabel, null, input.label)),
                                React.createElement(Field, { name: input.name, validate: input.validate, placeholder: input.placeholder }, function (_a) {
                                    var field = _a.field;
                                    return (React.createElement(StyledInput, __assign({ id: input.name, className: cn({
                                            error: errors[input.name] && touched[input.name],
                                        }), ref: input.ref }, field, { placeholder: input.placeholder, maxLength: equals("function", typeof input.maxLength)
                                            ? input.maxLength(values)
                                            : input.maxLength, onChange: function (event) {
                                            if (input.onChange) {
                                                input.onChange(event, setFieldValue);
                                            }
                                            else
                                                handleChange(event);
                                        }, onBlur: function (event) {
                                            if (input.onBlur) {
                                                input.onBlur(event, setFieldValue, setFieldTouched);
                                            }
                                            else
                                                handleBlur(event);
                                        }, autoComplete: input.autocomplete, inputMode: input.inputmode, "aria-label": input.ariaLabel, "aria-invalid": errors[input.name] && touched[input.name], "aria-describedby": input.name + "-error", "aria-required": inputRequired, required: inputRequired })));
                                }),
                                errors[input.name] && touched[input.name] ? (React.createElement(StyledErrorMessage, { id: input.name + "-error" }, errors[input.name])) : null));
                        }
                        if (inputDefinition.grouping instanceof Array) {
                            return (React.createElement(StyledGroupedFields, { key: "cc details" }, map(makeControl, inputDefinition.grouping)));
                        }
                        return makeControl(inputDefinition);
                    }, inputs),
                    React.createElement(StyledFormButton, null,
                        paymentError,
                        React.createElement("button", { type: "submit", disabled: submitDisabled(isValid, dirty) },
                            "Pay Check (", "" + checkInfo.balanceDue.add(tip).format(),
                            ")")))));
        })));
}
var templateObject_1, templateObject_2, templateObject_3, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;
